import React from 'react';

import AuthCard from 'ui-brand/components/AuthCard';
import Button from 'ui-brand/components/Button';

import SupportNote from './components/SupportNote';

function PlatformIntegrationCompleted() {
  return (
    <AuthCard
      title={gettext('Your store is already connected')}
      subtitle={gettext('This installation is linked to a Retino account. Continue to your dashboard.')}
    >
      <div className="mt-8">
        <Button variant="primary" size="lg" fullWidth arrow onClick={() => window.location.assign('/')}>
          {gettext('Go to dashboard')}
        </Button>
      </div>
      <SupportNote />
    </AuthCard>
  );
}

export default PlatformIntegrationCompleted;
